module.exports = __webpack_public_path__ + "img/autocolant_2023.48904752.png";